module.exports = "<div class=\"multiselect-parent btn-group dropdown-multiselect\">\n  <button type=\"button\" class=\"dropdown-toggle\" ng-disabled=\"disabled\" ng-class=\"settings.buttonClasses\" ng-click=\"toggleDropdown()\">{{getButtonText()}}&nbsp;\n    <span class=\"caret\"></span>\n  </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/common/multiselect/multiselect.html
// module id = 280
// module chunks = 1